export default "__VITE_ASSET__4dccaf01__"